import type React from 'react';
import styles from './index.module.scss';

import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogTitle,
} from '@/components/Dialog';
import { DialogDescription } from '@radix-ui/react-dialog';
import { VisuallyHidden } from '@radix-ui/react-visually-hidden';
import classNames from 'classnames';
import IconClose from './assets/close.svg';

type BasicDialogBodyProps = {
  align: 'left' | 'center';
  children: React.ReactNode;
};

export const BasicDialogBody: React.FC<BasicDialogBodyProps> = ({
  align,
  children,
}) => (
  <div
    className={classNames(styles.basicDialogBody, {
      [styles.basicDialogBodyLeft]: align === 'left',
      [styles.basicDialogBodyCenter]: align === 'center',
    })}
  >
    {children}
  </div>
);

type BasicDialogActionsProps = {
  children: React.ReactNode;
};

export const BasicDialogActions: React.FC<BasicDialogActionsProps> = ({
  children,
}) => <div className={styles.basicDialogActionsArea}>{children}</div>;

type BasicDialogProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  showCloseButton: boolean;
  title: string | React.ReactNode;
  description: string;
  closeLinkText?: string; // 下部のcloseリンク（オプショナル）
  children: React.ReactNode;
};

export const BasicDialog: React.FC<BasicDialogProps> = ({
  open,
  onOpenChange,
  showCloseButton,
  title,
  description,
  closeLinkText,
  children,
}) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <VisuallyHidden>
      <DialogDescription>{description}</DialogDescription>
    </VisuallyHidden>
    <DialogContent>
      <div className={styles.basicDialogContent}>
        {showCloseButton && (
          <DialogClose
            className={styles.basicDialogCloseButton}
            aria-label="閉じる"
          >
            <img src={IconClose} alt="" className={styles.iconClose} />
          </DialogClose>
        )}
        <DialogTitle className={styles.basicDialogTitle}>{title}</DialogTitle>

        {children}

        {closeLinkText && (
          <DialogClose className={styles.basicDialogCloseLink}>
            {closeLinkText}
          </DialogClose>
        )}
      </div>
    </DialogContent>
  </Dialog>
);
